import { render, staticRenderFns } from "./MessageRecovery.vue?vue&type=template&id=659c1d33"
import script from "./MessageRecovery.vue?vue&type=script&lang=js"
export * from "./MessageRecovery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports